export default __webpack_public_path__ + "static/media/modely4.9894ea56.jpg";